// AC-12 — formats a COMPLETED run's duration (CompletedAt - StartedAt) as compact text
// ("1m 12s", "48s"). Returns `null` (never NaN / "Invalid Date" / a negative duration) when
// a completed duration cannot be honestly computed: either timestamp missing/unparseable,
// or completedAt < startedAt (clock skew / bad data). Callers must treat `null` as "no
// completed duration" — the caller's own job is to render elapsed-so-far (a live ticker)
// or nothing in that case; this helper never fabricates one.
export const formatDurationMs = ms => {
	if (typeof ms !== 'number' || !Number.isFinite(ms) || ms < 0) {
		return null;
	}

	const totalSeconds = Math.floor(ms / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};

export const formatRunDuration = (startedAt, completedAt) => {
	if (!startedAt || !completedAt) {
		return null;
	}

	const started = new Date(startedAt);
	const completed = new Date(completedAt);

	if (Number.isNaN(started.getTime()) || Number.isNaN(completed.getTime())) {
		return null;
	}

	return formatDurationMs(completed.getTime() - started.getTime());
};

export default formatRunDuration;
